import {Route, Routes} from "react-router-dom";

// i18n
import {IntlProvider} from "react-intl";
import koMsg from './locale/ko.json';
import enMsg from './locale/en.json';
import deMsg from './locale/de.json';
import esMsg from './locale/es.json';
import frMsg from './locale/fr.json';
import jaMsg from './locale/ja.json';
import mnMsg from './locale/mn.json';
import viMsg from './locale/vi.json';
import zhTWMsg from './locale/zh-TW.json';
import zhCNMsg from './locale/zh-CN.json';
import ruMsg from './locale/ru.json';



// styles
import './styles/reset.scss';
import './styles/common.scss';
import './styles/mixins.scss';
import './styles/normalize.scss';
import './styles/pagination.scss';

// hooks
import {useLanguages} from "./hooks/useLanguages";

// components
import Login from "./components/Login/Login";
import LoginCallback from "./components/Login/LoginCallback";
import LoginErrorCallback from "./components/Login/LoginErrorCallback";
import GuardedRoute from "./utils/GuardedRoute";
import Main from "./components/Main/Main";
import LiveLecture from "./components/LiveLecture/LiveLecture";
import CompletionExamMain from "./components/CompletionExamMain/CompletionExamMain";
import CompletionExamRoom from "./components/CompletionExamRoom/CompletionExamRoom";

const lang = localStorage.getItem("lang") || 'ko';
const messages = {
  ko: koMsg,
  en: enMsg,
  de: deMsg,
  es: esMsg,
  fr: frMsg,
  ja: jaMsg,
  mn: mnMsg,
  vi: viMsg,
  "zh-CN": zhCNMsg,
  "zh-TW": zhTWMsg,
  ru: ruMsg
}[lang];

const App = () => {
  useLanguages();

  return (
    <IntlProvider locale={lang} messages={messages}>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='login'>
          <Route path='callback' element={<LoginCallback />} />
          <Route path='callback/error' element={<LoginErrorCallback/>} />
        </Route>

        {/*<Route element={<GuardedRoute />}>*/}
        {/*  <Route path='main' element={<Main />} />*/}
        {/*  <Route path='study'>*/}
        {/*    <Route path='live' element={<LiveLecture />} />*/}
        {/*  </Route>*/}
        {/*</Route>*/}

        <Route element={<GuardedRoute />}>
          <Route path='main' element={<CompletionExamMain />} />
          <Route path='exam-room/:id' element={<CompletionExamRoom />} />
        </Route>

      </Routes>
    </IntlProvider>
  );
}

export default App;
